import { cn } from "@utils/cn";
import { TableProps } from "./Table.types";

export const Table = ({ className, wrapperClassName, ...props }: TableProps) => {
    return (
        <div className={cn("w-full overflow-x-auto rounded-md", wrapperClassName)}>
            <table
                className={cn(
                    "w-full caption-bottom text-sm text-left border-collapse",
                    className
                )}
                {...props}
            />
        </div>
    );
};
